export { default as SimpleTD, getTextAndTitle } from './src/simple-td';
